import { render, staticRenderFns } from "./style_list.vue?vue&type=template&id=20d7de08&"
import script from "./style_list.vue?vue&type=script&lang=js&"
export * from "./style_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports